<template>
  <div class="animated fadeIn">
    <b-breadcrumb><strong>Inspection List</strong></b-breadcrumb>

    <b-row>
      <!----- SideBar All Design List ---->
      <!-- <sidebarSettingsComponent></sidebarSettingsComponent> -->
      <!----- SideBar All Design List End ---->

      <div class="design-container-details__main">
        <div class="col-md-12 ">
          <!-- code for table -->
          <b-row>
            <b-col md="12">
              <b-card-body>
                <b-form
                @submit.prevent="validateForm3('form-5')"
                data-vv-scope="form-5"
                >
            
               <div class="row ">
                    <div class="col-md mx-1 col-12 mt-2">
                        <ejs-multiselect
                            id="vendor_search_name"
                            placeholder="Select Vendor Name"
                            v-model="vendor_search_name"
                            name="vendor_search_name"
                            :fields="vendor_listt"
                            :dataSource="vendor_list"
                            :showSelectAll="true"
                            :class="{ input: true }"
                        >
                        </ejs-multiselect>
                    </div>
                    <div class="col-md mx-1 col-12 mt-2">
                        <ejs-multiselect
                            id="buyer_search_name"
                            placeholder="Select Buyer Name"
                            v-model="buyer_search_name"
                            name="buyer_search_name"
                            :fields="buyer_listt"
                            :dataSource="buyer_list"
                            :showSelectAll="true"
                            :class="{ input: true }"
                        >
                        </ejs-multiselect>
                    </div>
                    <div class="col-md mx-1 col-12 mt-2">
                        <ejs-multiselect
                            id="inspection_qcname"
                            placeholder="Select QC Name"
                            v-model="inspection_qcname"
                            name="inspection_qcname"
                            :fields="qc_listt"
                            :dataSource="qc_list"
                            :showSelectAll="true"
                            :class="{ input: true }"
                        >
                        </ejs-multiselect>
                    </div>
                    <div class="col-md mx-1 col-12 mt-2">
                        <b-form-select
                            class="uploaded_inspection_type"
                            v-model="uploaded_inspection_type"
                            :options="options4"
                            id="uploaded_inspection_type"
                            name="uploaded_inspection_type"
                        >
                        </b-form-select>
                    </div>
                    <div class="col-md mx-1 col-12 mt-2" v-if="this.$route.params.id==undefined || this.$route.params.id=='' || this.$route.params.id==null">
                        <b-form-select
                            v-model="inspectionStatus"
                            :options="options5"
                            id="inspectionStatus"
                            name="inspectionStatus"
                        >
                        </b-form-select>
                    </div>
                </div>

                <!--  -->


                <div class="row ">
                    <div class="col-md mx-1 col-12 mt-2">
                        <datepicker
                        :bootstrap-styling="true"
                        placeholder="Select From Date"
                        slot="beforeCalendarHeader"
                        class="calender-header"
                        v-model="inspection_date"
                        id="enddate"
                        :format="DatePickerFormat"
                        :disabledDates="disabledDatess"
                        required
                    >
                        Inspection From Date
                    </datepicker>
                    </div>
                    <div class="col-md mx-1 col-12 mt-2">
                       <datepicker
                        :bootstrap-styling="true"
                        placeholder="Select To Date"
                        slot="beforeCalendarHeader"
                        class="calender-header"
                        v-model="inspection_to_date"
                        id="enddate"
                        :format="DatePickerFormat"
                        :disabledDates="disabledDatess"
                        required
                    >
                        Inspection To Date
                    </datepicker>
                    </div>
                    <div class="col-md mx-1 col-12 mt-2">
                        <b-form-select
                        v-model="inspectionzone"
                        :options="options1"
                        id="inspectionzone"
                        name="inspectionzone"
                    >
                        <!-- <option :value="select" >--Select--</option> -->
                    </b-form-select>
                    </div>

                    <div class="col-md mx-1 col-12 mt-2">
                      <b-form-select
                      v-model="inspectionStyleType"
                      :options="options6"
                      id="inspectionStyleType"
                      name="inspectionStyleType"
                  >
                      <!-- <option :value="select" >--Select--</option> -->
                  </b-form-select>
                  </div>
                    
                    <div class="col-md mx-1 col-12 mt-2">
                      <b-form-select
                            v-model="location"
                            :options="options3"
                            id="location"
                            name="location"
                        >
                        </b-form-select>
                    </div>
                    <div class="col-md mx-1 col-12 mt-2">
                         <input class="form-control" placeholder="Enter Seach Query Here" type="text" v-model="seachdata" name="seachdata" id="seachdata"/>
                    </div>
                </div>

                 <b-row style="float:right;" class="mt-3">
                    <b-col md="12">
                    <b-form-group style="float:left;"
                        >&nbsp;
                        <b-button variant="primary" type="submit">Search</b-button>
                    </b-form-group>
                    <b-form-group style="float:left;"
                        >&nbsp;
                        <b-button
                        variant="primary"
                        type="reset"
                        @click="clearformdata()"
                        >Clear Search</b-button
                        >
                    </b-form-group>
                    </b-col>
                </b-row>

<!-- 

                <div class="row mt-2">
                    <div class="col mx-1 ">
                    
                    </div>
                    <div class="col mx-1 ">
                    
                    </div>
                    <div class="col mx-1 ">
                    
                    </div>
                    <div class="col mx-1 ">
                    <b-form-select
                        v-model="location"
                        :options="options3"
                        id="location"
                        name="location"
                    >
                    </b-form-select>
                    </div>
                    <div class="col mx-1 ">
                    <input class="form-control" placeholder="Enter Seach Query Here" type="text" v-model="seachdata" name="seachdata" id="seachdata"/>
         
                    </div>
                </div> -->

               
                </b-form>
                 
                <b-row style="float:right;" class="mt-3">
                 
                <b-col md="12">
                  <b-button class="mr-2" variant="success" @click="getallSubcategoryData()" download>Download
                      SubCategory</b-button>

                    <b-button
                    class="mr-2"
                    variant="success"
                    @click="getapprovedInspectiondownload()"
                    download
                    >Download Approved List</b-button
                    >

                    <b-button
                    class="mr-2"
                    variant="success"
                    @click="getaAllInspectiondownload()"
                    download
                    >Download All</b-button
                    >

                    <b-button
                    v-if="this.user_type == 'Buyer' || this.user_type == 'Junior_Buyer' || this.user_type == 'Buying_Head'"
                    title="Upload Inspection Manually"
                    variant="success"
                    class="mr-2"
                    @click="uploadfilemodelfunction()"
                    download
                    :disabled="this.isUploadDisabled"
                    ><i class="fa fa-upload"></i
                    ></b-button>

                    <b-button
                    variant="success"
                    title="Download sample file"
                    v-if="this.user_type == 'Buyer' || this.user_type == 'Junior_Buyer' || this.user_type == 'Buying_Head'"
                    ><a
                        href="../img/inscsv.csv"
                        target="_blank"
                        download
                        style="color:white;"
                        ><i class="fa fa-download"></i></a
                    ></b-button>
                </b-col>
                </b-row>
                
              </b-card-body>
            </b-col>

            <b-col v-if="this.user_type == 'Quality_Controller'">
                 <b-form style="margin-left:-10px"
                @submit.prevent="validateForm6('form-6')"
                data-vv-scope="form-6"
                class="mt-3 mb-4"
                
                >
                <b-row >
                  <b-col class="col-md-3 col-12 ml-1 mr-2">

                    <b-form-select
                        v-model="selected_qc_id"
                        id="qc_name"
                        name="qc_name"
                        v-validate="'required'"
                        :class="{
                        input: true,
                        'is-invalid': errors.has('form-1.qc_name'),
                        }"
                    >
                        <option value="">Select Option</option>
                        <option
                        :value="qc_name.user_id"
                        v-for="qc_name in qc_name_arr"
                        :key="qc_name"
                        >{{ qc_name.full_name }}</option
                        >
                    </b-form-select>
                    </b-col>

          
                    <b-col class="col-md-4 col-12 ml-1 mr-2">
                    <b-button
                        type="submit"
                        class="btn col-md-5"
                        variant="primary"
                        >Assign Inspection</b-button
                    >
                    </b-col>
                </b-row>
                </b-form>
            </b-col>

          </b-row>
          
          <input
              class="aprrovedcheck"
              type="checkbox"
              @click="checkAll()"
              v-model="isCheckAll"
              v-if="this.user_type == 'Quality_Controller'"
            />
            &nbsp;<label v-if="this.user_type == 'Quality_Controller'">
              Check All</label
            >
            <br>
             <b>Inspection List</b>
                <p class="text-right">
                <b style="margin-right:5%" v-if="dataFound == true"
                    >Total Records :<span style="color:red;">{{
                    this.list_totalRows
                    }}</span></b
                >
                </p>


        </div>
      </div>

        
      <div style="overflow-x: auto; width: 100%; white-space: nowrap;" class="ml-1 px-2">   
        <b-table 
            striped 
            hover 
            :items="inspection_data"
            :bordered="true"
            :fields="inspection_fields"
            class="table-responsive">
                     <template slot-scope="row">
                     <div  v-if="dataFound == false">
                        {{dataFound}}
                    </div>
                    </template>

                    <template slot="checkbox" slot-scope="row">
                        <input
                        type="checkbox"
                        v-if="
                            (row.item.inspection_status == 'Approved' ||
                            row.item.inspection_status == 'Carry Forward' ||
                            row.item.inspection_status == 'Pending' ||
                            row.item.inspection_status == 'Scheduled' ||
                            row.item.inspection_status == 'Cancel') &&
                            row.item.loginuser == 'Quality_Controller'
                        "
                        @change="
                            (e) => handleCheck(row.item.inspection_id, e.target.checked)
                        "
                        v-model="checked_values"
                        required="checked_values"
                        v-bind:value="row.item.inspection_id"
                        />
                    </template>

                    <template slot="stylcode" slot-scope="row">
                        <p >{{ row.item.style_code }}</p>
                    </template>

                    <template slot="offeredquantityslot" slot-scope="row">
                        <p
                        v-if="
                            row.item.offered_quantity == null ||
                            row.item.offered_quantity == ''
                        "
                        >
                        NA
                        </p>
                        <p
                        v-if="
                            row.item.offered_quantity != null ||
                            row.item.offered_quantity != ''
                        "
                        >
                        {{ row.item.offered_quantity }}
                        </p>
                    </template>
                    <template slot="showDate" slot-scope="row">
                        <p v-if="row.item.inspection_date != null">
                        <!-- {{ row.item.inspection_date }} -->

                        {{
                            new Date(row.item.inspection_date).getDate() +
                            "/" +
                            (new Date(row.item.inspection_date).getMonth() + 1) +
                            "/" +
                            new Date(row.item.inspection_date).getFullYear()
                        }}
                        </p>
                    </template>

                    <template slot="vendor_name" slot-scope="row">
                    
                        <p class="loct">{{ row.item.vendor_name }}</p>
                    </template>

                    <template slot="loc" slot-scope="row">
                        <p class="loct">{{ row.item.location +'-'+ row.item.zone }}</p>
                    </template>

                    <template slot="createdslot" slot-scope="row">
                        <p class="loct">{{ row.item.created_by  }}</p>
                    </template>
                    
                    <template slot="allocate_to" slot-scope="row">
                        <p
                        v-if="
                            row.item.qcusername == null || row.item.qcusername == ''
                        "
                        >
                        NA
                        </p>
                        <p
                        v-if="
                            row.item.qcusername != null || row.item.qcusername != ''
                        "
                        >
                        {{ row.item.qcusername }}
                        </p>
                    </template>

                    <template slot="style_type" slot-scope="row">
                      <p v-if="row.item.styletype">
                      {{ row.item.styletype }}
                      </p>
                      <p v-else>
                       apparel
                      </p>
                  </template>

                    <template slot="inpection_uploaded_satus" slot-scope="row">
                        <p v-if="row.item.inspection_flag == 'Direct'">
                        System
                        </p>
                        <p v-if="row.item.inspection_flag != 'Direct'">
                        {{ row.item.inspection_flag }}
                        </p>
                    </template>

                

                    <template slot="protoactions" slot-scope="row">
                        <b-dropdown
                        variant="link"
                        toggle-class="text-decoration-none"
                        no-caret
                        >
                        <template v-slot:button-content>
                            <span class="cui-options icons font-1xl d-block"></span>
                        </template>

                        <b-dropdown-item>
                            <span
                            v-b-modal.Detailsprotomodel
                            @click="editinfoModal(row.item)"
                            >
                            Show Details
                            </span>
                        </b-dropdown-item>
                        <!-- Quality_Controller -->
                        <b-dropdown-item v-if="row.item.inspection_status != 'Hold' && user_type == 'Quality_Controller'">
                            <span
                            v-b-modal.Detailsprotomodel
                            @click="markasholdfun(row.item.inspection_id)"
                            >
                            Mark as hold
                            </span>
                        </b-dropdown-item>
                        
                        </b-dropdown>
                    </template>


        </b-table>

           <b-col md="6" class="my-1 mb-2" style="overflow-x: auto; width: 100%; white-space: nowrap;">

              <paginate
                v-if="this.inspection_data.length > 0"
                v-model="page"
                :page-count="noofpages"
                :page-range="10"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'"
                :current-page="currentPage"
              >
              </paginate>
            </b-col>

      </div>   


      
       <!-- Add brand Model -->
      <b-modal
        title="Select Brand Name"
        v-model="brand_model"
        @ok="brand_model = false">
        <b-form
          name="fileform"
          @submit.prevent="validateForm2('form-1')"
          data-vv-scope="form-1"
        >
          <b-col class="filedesign">
            <b-col sm="12">
              <b-form-group>
                  <b-form-select
                    v-model="selected_brandID"
                    id="brand_name"
                    name="brand_name"
                    v-validate="'required'"
                    :class="{
                      input: true,
                      'is-invalid': errors.has('form-1.brand_name'),
                    }"
                  >
                    <option value="">Select Option</option>
                    <option
                      :value="brand_name.brand_id +'-'+ brand_name.brand_title"
                      v-for="brand_name in brand_name_arr"
                      :key="brand_name"
                      >{{ brand_name.brand_title }}</option
                    >
                  </b-form-select>

                  <b-form-select hidden
                    v-model="selected_brand_name"
                    id="brand_name"
                    name="brand_name"
                   
                  >
                    <option value="">Select Option</option>
                    <option
                      :value="brand_name.brand_title"
                      v-for="brand_name in brand_name_arr"
                      :key="brand_name"
                      >{{ brand_name.brand_title }}</option
                    >
                  </b-form-select>
   
              </b-form-group>
            </b-col>
            <div slot="footer" id="upload_btn">
              <b-button
                type="submit"
                style="float:right"
                variant="primary"
                class="px-4"
                >OK</b-button
              >
            </div>
          </b-col>
        </b-form>
      </b-modal>
      <!--  End brand File Model -->

      <!-- Add  mark as holdModel -->
      <b-modal
        title="Mark As Hold"
        v-model="markasholdmodal"
        @ok="markasholdmodal = false">
        <b-form
          name="fileform"
          @submit.prevent="validateForm8('form-1')"
          data-vv-scope="form-1"
        >
          <b-col class="filedesign">
            <b-col sm="12">
              <p>Are you sure?</p>
            </b-col>
            <div slot="footer" id="upload_btn">
            <b-button
                @click="cancelmarkasholdmodal();"
                style="float:right"
                variant="danger"
                class="px-4"
                >Cancel</b-button
              >
              <b-button
                 @click="submitmarkasholdmodal();"
                style="float:right"
                variant="primary"
                class="px-4 mr-2"
                >Confirm</b-button
              >
               
            </div>
          </b-col>
        </b-form>
      </b-modal>
      <!--  End mark as hold Model -->
      

      <!-- Add File Model -->
      <b-modal
        title="Upload File (For Manual Inspection)"
        v-model="uploadfilemodel"
        @ok="uploadfilemodel = false">
        <b-form
          name="fileform"
          @submit.prevent="validateForm('form-1')"
          data-vv-scope="form-1"
        >
          <b-col class="filedesign">
            <b-col sm="12">
              <b-form-group>
                <label for="name">Upload File</label>
                
                  <div class="row g-0" id="staicuploadfile">
                    <div class="col-sm-6 col-md-11">
                      <input type="text" placeholder="Upload CSV File" class="form-control" disabled style="border:1px solid grey;"/>
                    </div>
                    <div class="col-6 col-md-1" style="margin-left:-30px;">
                      <button class="btn btn-light" type="button" @click="getbrand_mode();">Browse</button>
                    </div>
                  </div>
                <!-- </div> -->
                <div id="dynamicuploadfile" style="display:none;">
                <b-form-file
                  v-model="file"
                  :state="Boolean(file)"
                  accept=".csv" 
                  placeholder="Upload Inspection CSV File"
                  @change="selectFile($event)"
                  required
                  :class="{
                    input: true,
                    'text-danger': errors.has('form-1.file'),
                  }"
                ></b-form-file>
                </div>
                <span style="color:#ff0000;"
                  >Date format should be DD-MM-YYYY</span
                >
                <b-input-group>
                  <span class="icon has-text-warning">
                    <i class="fa fa-warning" v-show="errors.has('file')"></i>
                  </span>
                  <span
                    style="width:240px"
                    v-show="errors.has('form-1.file')"
                    class="help text-danger"
                    >{{ errors.first("form-1.file") }}</span
                  >
                </b-input-group>

                <!-- Code For Progress Bar -->
                <div
                  class="progress"
                  id="progress_bar"
                  style="display:none; margin-top: 7px; margin-bottom: 7px; width: 100%; height: 30px;font-size: 18px; font-weight: bold;"
                >
                  <div
                    class="progress-bar progress-bar-info progress-bar-striped"
                    role="progressbar"
                    :aria-valuenow="progress"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    :style="{
                      height: '30px',
                      text: '20px',
                      align: 'center',
                      width: progress + '%',
                    }"
                  >
                    {{ progress }}%
                  </div>
                </div>
                <!-- Code For Progress Bar Ends -->
              </b-form-group>
            </b-col>
            <div slot="footer" id="upload_btn">
              <b-button
                type="submit"
                style="float:right"
                variant="primary"
                class="px-4"
                >Upload File</b-button
              >
            </div>
          </b-col>
        </b-form>
      </b-modal>
      <!--  End Add File Model -->


         <!-- Code for Edit  -->
        <b-modal
          title="Allocate Inspection"
          v-model="allocate_inspection"
          @ok="allocate_inspection = false"
          size="xl"
        >
          <template slot="modal-header" slot-scope="{ close }">
            <h5>Allocate Inspection</h5>
            <b-form-group style="float:right;">
              <b-button variant="danger" @click="editcancel()"
                ><i class="fa fa-times"></i
              ></b-button>
            </b-form-group>
          </template>

          <template slot="default" slot-scope="{ hide }">
            <div>
              <b-card no-body>
                <b-tabs pills card>
                  <b-tab title="Style Detail Information" active>
                    <b-card-text>
                      <!-- INFORMATION TAB STARTS HERE -->

                      <b-row>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Style Name :</b></label>
                            </b-col>

                            <b-col md="12" class="pull-right titleb"
                              >{{ selected_inspection_data.style_name }}
                            </b-col>
                          </b-form-group>
                        </b-col>

                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Style Code :</b></label>
                            </b-col>
                            <!-- -->
                            <b-col md="12" class="pull-right titleb"
                              >{{ selected_inspection_data.style_code }}
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Style Color :</b></label>
                            </b-col>
                            <!-- -->
                            <b-col md="12" class="pull-right titleb"
                              >{{ selected_inspection_data.color }}
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"
                                ><b>Product Description :</b></label
                              >
                            </b-col>
                            <!-- -->
                            <b-col md="12" class="pull-right titleb">
                              {{ selected_inspection_data.style_description }}
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Buyer Name :</b></label>
                            </b-col>
                            <!-- -->
                            <b-col md="12" class="pull-right titleb"
                              >{{ selected_inspection_data.buyer_name }}
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Vendor Name :</b></label>
                            </b-col>
                            <!-- -->
                            <b-col md="12" class="pull-right titleb"
                              >{{ selected_inspection_data.vendor_name }}
                            </b-col>
                          </b-form-group>
                        </b-col>

                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>PO no. :</b></label>
                            </b-col>

                            <b-col md="12" class="pull-right titleb"
                              >{{ selected_inspection_data.po_id }}
                            </b-col>
                          </b-form-group>
                        </b-col>

                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Brand Name :</b></label>
                            </b-col>

                            <b-col md="12" class="pull-right titleb">
                              {{ selected_inspection_data.brand_title }}
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Location :</b></label>
                            </b-col>

                            <b-col
                              v-if="
                                selected_inspection_data.location != null ||
                                  selected_inspection_data.location != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.location }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.location == null ||
                                  selected_inspection_data.location == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-row
                        v-if="
                          selected_inspection_data.inspection_status ==
                            'Requested' &&
                            (user_type == 'Brand_Manager' ||
                              user_type == 'Buyer')
                        "
                      >
                        <b-form
                          @submit.prevent="validateForm4('form-5')"
                          data-vv-scope="form-5"
                        >
                          <b-col md="12">
                            <b-form-group>
                              <b-col md="8" class="pull-left">
                                <label for="actionforapproveqc"
                                  ><b>Action</b>
                                  <span style="color:red;">*</span>
                                </label>
                              </b-col>
                              <b-col class="d-flex flex-flow" md-4>
                                <b-form-select
                                  v-model="actionforapproveqc"
                                  :options="options2"
                                  id="actionforapproveqc"
                                  name="actionforapproveqc"
                                  required
                                >
                                </b-form-select>

                                <b-form-input
                                  type="text"
                                  :value="
                                    selected_inspection_data.inspection_id
                                  "
                                  v-model="inspection_id"
                                  hidden
                                >
                                </b-form-input>

                                <b-button
                                  type="submit"
                                  class="ml-2 col-md-4"
                                  variant="primary"
                                  >Submit</b-button
                                >
                              </b-col>
                            </b-form-group>
                          </b-col>
                        </b-form>
                      </b-row>

                      <b-form
                        @submit.prevent="validateForm5('form-5')"
                        data-vv-scope="form-5"
                        class="mt-2"
                      >
                        <b-row
                          v-if="
                            user_type == 'Quality_Controller' &&
                              (selected_inspection_data.inspection_status ==
                                'Approved' ||
                               selected_inspection_data.inspection_status == 
                                'Carry Forward' ||
                                selected_inspection_data.inspection_status ==
                                  'Pending' ||
                                selected_inspection_data.inspection_status ==
                                  'Scheduled' ||
                                selected_inspection_data.inspection_status ==
                                  'Cancel')
                          "
                        >
                          <!-- <b-form-group> -->
                          <!-- <b-col md="6"> -->
                          <!-- <label for="name"><b>Inspection For QC </b> <span style="color:red;">*</span> </label> -->
                          <!-- </b-col>  -->
                          <b-col md="4">
                            <!-- <ejs-multiselect id='qc_name' placeholder="Select QC Name" v-model="selected_qc_id" name="qc_name"  :fields='qc_listt'  :dataSource='qc_list' :showSelectAll='true' :class="{ 'input': true }" >
                          
                        </ejs-multiselect> -->

                            <b-form-select
                              v-model="selected_qc_id"
                              id="qc_name"
                              name="qc_name"
                              v-validate="'required'"
                              :class="{
                                input: true,
                                'is-invalid': errors.has('form-1.qc_name'),
                              }"
                            >
                              <option value="">Select Option</option>
                              <option
                                :value="qc_name.user_id"
                                v-for="qc_name in qc_name_arr"
                                :key="qc_name"
                                >{{ qc_name.full_name }}</option
                              >
                            </b-form-select>

                            <b-form-input
                              type="text"
                              :value="selected_inspection_data.inspection_id"
                              v-model="inspection_id"
                              hidden
                            >
                            </b-form-input>
                          </b-col>

                          <!-- </b-form-group> -->
                          <b-col md="4">
                            <b-button
                              type="submit"
                              class="btn ml-2 col-md-5"
                              variant="primary"
                              >Submit</b-button
                            >
                          </b-col>
                        </b-row>
                      </b-form>

                      <b-row
                        class=""
                        v-if="
                          selected_inspection_data.inspection_status == 'RFT' ||
                            selected_inspection_data.inspection_status == 'Hold'
                        "
                      >
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>MRP :</b></label>
                            </b-col>

                            <b-col
                              v-if="
                                selected_inspection_data.mrp != null ||
                                  selected_inspection_data.mrp != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.mrp }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.mrp == null ||
                                  selected_inspection_data.mrp == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Total Quantity :</b></label>
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.total_quantity !=
                                  null ||
                                  selected_inspection_data.total_quantity != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.total_quantity }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.total_quantity ==
                                  null ||
                                  selected_inspection_datatotal_quantity == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"
                                ><b>Inspected Quantity :</b></label
                              >
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.inspection_quantity !=
                                  null ||
                                  selected_inspection_data.inspection_quantity !=
                                    ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{
                                selected_inspection_data.inspection_quantity
                              }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.inspection_quantity ==
                                  null ||
                                  selected_inspection_data.inspection_quantity ==
                                    ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                            <!-- <b-col md="12" class="pull-right titleb">{{inspection_quantity}}
                        </b-col> -->
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Passed Quantity :</b></label>
                            </b-col>

                            <b-col
                              v-if="
                                selected_inspection_data.passed_quantity !=
                                  null ||
                                  selected_inspection_data.passed_quantity != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.passed_quantity }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.passed_quantity ==
                                  null ||
                                  selected_inspection_data.passed_quantity == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{passed_quantity}}
                        </b-col> -->
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"
                                ><b>Rc/Reject/Defect Quantity :</b></label
                              >
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{reject_quantity}}
                        </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.reject_quantity !=
                                  null ||
                                  selected_inspection_data.reject_quantity != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.reject_quantity }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.reject_quantity ==
                                  null ||
                                  selected_inspection_data.reject_quantity == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"
                                ><b>No. of Carton Inspected :</b></label
                              >
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{carton_inspected}}
                        </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.carton_inspected !=
                                  null ||
                                  selected_inspection_data.carton_inspected !=
                                    ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.carton_inspected }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.carton_inspected ==
                                  null ||
                                  selected_inspection_data.carton_inspected ==
                                    ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Inspection Type :</b></label>
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{inspection_type}}
                        </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.inspection_type !=
                                  null ||
                                  selected_inspection_data.inspection_type != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.inspection_type }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.inspection_type ==
                                  null ||
                                  selected_inspection_data.inspection_type == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"
                                ><b>Inspection Process :</b></label
                              >
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{inspection_process}}
                        </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.inspection_process !=
                                  null ||
                                  selected_inspection_data.inspection_process !=
                                    ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.inspection_process }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.inspection_process ==
                                  null ||
                                  selected_inspection_data.inspection_process ==
                                    ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"
                                ><b>Stitching Quality :</b></label
                              >
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{stiching_quality}}
                        </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.stiching_quality !=
                                  null ||
                                  selected_inspection_data.stiching_quality !=
                                    ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.stiching_quality }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.stiching_quality ==
                                  null ||
                                  selected_inspection_data.stiching_quality ==
                                    ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Wash Care Label :</b></label>
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{wash_lable}}
                        </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.wash_lable != null ||
                                  selected_inspection_data.wash_lable != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.wash_lable }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.wash_lable == null ||
                                  selected_inspection_data.wash_lable == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Hang Tag :</b></label>
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{hand_teg}}
                        </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.hand_teg != null ||
                                  selected_inspection_data.hand_teg != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.hand_teg }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.hand_teg == null ||
                                  selected_inspection_data.hand_teg == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Main Label :</b></label>
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{main_label}}
                        </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.main_label != null ||
                                  selected_inspection_data.main_label != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.main_label }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.main_label == null ||
                                  selected_inspection_data.main_label == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Size Label :</b></label>
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{size_label}}
                        </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.size_label != null ||
                                  selected_inspection_data.size_label != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.size_label }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.size_label == null ||
                                  selected_inspection_data.size_label == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Fabric Color :</b></label>
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{fabric_color}}
                        </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.fabric_color != null ||
                                  selected_inspection_data.fabric_color != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.fabric_color }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.fabric_color == null ||
                                  selected_inspection_data.fabric_color == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Fabric Quality :</b></label>
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{fabric_quality}}
                        </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.fabric_quality !=
                                  null ||
                                  selected_inspection_data.fabric_quality != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.fabric_quality }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.fabric_quality ==
                                  null ||
                                  selected_inspection_data.fabric_quality == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Print Quality :</b></label>
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{print_quality}}
                        </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.print_quality !=
                                  null ||
                                  selected_inspection_data.print_quality != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.print_quality }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.print_quality ==
                                  null ||
                                  selected_inspection_data.print_quality == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Embroidery :</b></label>
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{embroidery}}
                        </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.embroidery != null ||
                                  selected_inspection_data.embroidery != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.embroidery }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.embroidery == null ||
                                  selected_inspection_data.embroidery == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"
                                ><b>Button Hole/Attachment :</b></label
                              >
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{button_hole}}
                        </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.button_hole != null ||
                                  selected_inspection_data.button_hole != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.button_hole }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.button_hole == null ||
                                  selected_inspection_data.button_hole == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"
                                ><b>Barcode With MRP :</b></label
                              >
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{barcode_mrp}}
                        </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.barcode_mrp != null ||
                                  selected_inspection_data.barcode_mrp != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.barcode_mrp }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.barcode_mrp == null ||
                                  selected_inspection_data.barcode_mrp == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"
                                ><b>Over Lock Stitch Quality :</b></label
                              >
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{overlook_quality}}
                        </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.overlook_quality !=
                                  null ||
                                  selected_inspection_data.overlook_quality !=
                                    ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.overlook_quality }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.overlook_quality ==
                                  null ||
                                  selected_inspection_data.overlook_quality ==
                                    ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>

                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>GPT :</b></label>
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{gpt}}
                        </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.gpt != null ||
                                  selected_inspection_data.gpt != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.gpt }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.gpt == null ||
                                  selected_inspection_data.gpt == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>

                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>AQL :</b></label>
                            </b-col>
                            <b-col md="12">
                              <table class="table table-bordered">
                                <tr>
                                  <th>Major</th>
                                  <th>Minor</th>
                                  <th>Critical</th>
                                </tr>
                                <tr>
                                  <td>
                                    <p
                                      v-if="
                                        selected_inspection_data.aql.Major ==
                                          null ||
                                          selected_inspection_data.aql.Major ==
                                            ''
                                      "
                                    >
                                      NA
                                    </p>
                                    <p
                                      v-if="
                                        selected_inspection_data.aql.Major !=
                                          null ||
                                          selected_inspection_data.aql.Major !=
                                            ''
                                      "
                                    >
                                      {{ selected_inspection_data.aql.Major }}
                                    </p>
                                  </td>

                                  <td>
                                    <p
                                      v-if="
                                        selected_inspection_data.aql.Minor ==
                                          null ||
                                          selected_inspection_data.aql.Minor ==
                                            ''
                                      "
                                    >
                                      NA
                                    </p>
                                    <p
                                      v-if="
                                        selected_inspection_data.aql.Minor !=
                                          null ||
                                          selected_inspection_data.aql.Minor !=
                                            ''
                                      "
                                    >
                                      {{ selected_inspection_data.aql.Minor }}
                                    </p>
                                  </td>

                                  <td>
                                    <p
                                      v-if="
                                        selected_inspection_data.aql.Critical ==
                                          null ||
                                          selected_inspection_data.aql
                                            .Critical == ''
                                      "
                                    >
                                      NA
                                    </p>
                                    <p
                                      v-if="
                                        selected_inspection_data.aql.Critical !=
                                          null ||
                                          selected_inspection_data.aql
                                            .Critical != ''
                                      "
                                    >
                                      {{
                                        selected_inspection_data.aql.Critical
                                      }}
                                    </p>
                                  </td>
                                </tr>
                              </table>
                            </b-col>

                            <!-- <b-col v-if="selected_inspection_data.aql !=null || selected_inspection_data.aql != ''" md="12" class="pull-right titleb">{{selected_inspection_data.aql}}
                        </b-col>
                        <b-col v-if="selected_inspection_data.aql ==null || selected_inspection_data.aql ==''" md="12" class="pull-right titleb">NA
                        </b-col> -->
                          </b-form-group>
                        </b-col>

                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"
                                ><b
                                  >Checked Against Size Chart (Within / Out of )
                                  Tolerance :</b
                                ></label
                              >
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{size_chart}}
                        </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.size_chart != null ||
                                  selected_inspection_data.size_chart != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.size_chart }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.size_chart == null ||
                                  selected_inspection_data.size_chart == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>

                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"
                                ><b
                                  >Checked Against PP Sample/Comments Sheet :</b
                                ></label
                              >
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{check_pp_sample}}
                        </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.check_pp_sample !=
                                  null ||
                                  selected_inspection_data.check_pp_sample != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.check_pp_sample }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.check_pp_sample ==
                                  null ||
                                  selected_inspection_data.check_pp_sample == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <div slot="footer" class="text-right mt-12">
                        <a
                          :href="selected_inspection_data.report_file_path"
                          target="_blank"
                          download
                        >
                          <!-- v-if="selected_inspection_data.inspection_status == 'RFT' ||selected_inspection_data.inspection_status == 'Hold'" -->
                          <b-button
                            type="submit"
                            class="mr-2"
                            variant="success"
                            v-if="
                              selected_inspection_data.inspection_status !=
                                'Pending' &&
                                selected_inspection_data.inspection_status !=
                                  'Approved' &&
                                selected_inspection_data.inspection_status !=
                                  'Scheduled'
                            "
                            >Download</b-button
                          >
                        </a>
                        <b-button variant="danger" @click="editcancel()"
                          >cancel</b-button
                        >
                      </div>
                    </b-card-text>
                  </b-tab>

                  <!-- ~~~~~INFORAMTION TAB ENDS HERE~~~~~~~ -->

                  <!-- ~~~~~~~~~~~~~ COMMENT TAB~~~~~~~~~~~~~~ -->
                  <b-tab
                    title="Comments"
                    v-if="
                      selected_inspection_data.inspection_status != 'Pending' &&
                        selected_inspection_data.inspection_status !=
                          'Approved' &&
                        selected_inspection_data.inspection_status !=
                          'Scheduled'
                    "
                  >
                    <b-card-text>
                      <b-row
                        v-for="comment_item in comment_details"
                        :key="comment_item"
                      >
                        <b-col md="12">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <!-- <label for="name"><b>{{comment_label}}:</b></label> -->
                            </b-col>
                            <b-col
                              >{{ comment_item.defect_type }} -
                              {{ comment_item.message }}
                            </b-col>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </b-tab>

                  <!-- ~~~~~~~~~~~~~~ Comment sab ends  ~~~~~~~~~~~~~~~~~~~-->

                  <!-- ~~~~~~~~~~~~ Image tab starts ~~~~~~~~~~~~~~~~~~~~~ -->

                  <b-tab
                    title="Images"
                    v-if="
                      selected_inspection_data.inspection_status != 'Pending' &&
                        selected_inspection_data.inspection_status !=
                          'Approved' &&
                        selected_inspection_data.inspection_status !=
                          'Scheduled'
                    "
                  >
                    <div
                      class="accordion"
                      role="tablist"
                      v-for="(image_item, index) in image_details"
                      :key="image_item"
                    >
                      <b-card no-body class="mb-1">
                        <b-card-header
                          header-tag="header"
                          class="p-1"
                          role="tab"
                        >
                          <b-button
                            block
                            v-b-toggle="'accordion' + index"
                            variant="light"
                            style="text-align: left;"
                            >{{ image_item.image_type }}</b-button
                          >
                        </b-card-header>
                        <b-collapse
                          :id="'accordion' + index"
                          accordion="my-accordion"
                          role="tabpanel"
                        >
                          <b-card-body class="mt-3">
                            <p
                              class="ml-3"
                              v-if="
                                image_item.image_path == null ||
                                  image_item.image_path == ''
                              "
                            >
                              No Data
                            </p>

                            <img
                              v-for="image in image_item.image_path"
                              :src="image"
                              :key="image"
                              @click="openimage(image)"
                              height="100px"
                              width="100px"
                              style="padding:5px; cursor: pointer;"
                            />
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                    </div>
                  </b-tab>

                  <!-- ~~~~~~~~~~~~~~Image tab ends ~~~~~~~~~~~~~~~~~~~~~~~ -->
                </b-tabs>
              </b-card>
            </div>

            <template slot="modal-footer" slot-scope="{ hide }">
              <!-- Emulate built in modal footer ok and cancel button actions -->
              <b-button size="sm" style="display:none">
                Cancel
              </b-button>
            </template>
          </template>
        </b-modal>

        <!-- Image Zoom Model -->
        <b-modal
          id="modal-lg"
          size="lg"
          title="Image Zoom"
          v-model="openimagemodel"
          @ok="openimagemodel = false"
        >
          <template slot="modal-header">
            <h5>Zoom Image</h5>

            <b-button
              size="sm"
              @click="openimagecancel()"
              style="background: none; border: none;"
              ><i class="fa fa-close"></i
            ></b-button>
          </template>
          <template slot="default" slot-scope="{ hide }">
            <div class="main1 mb-3" style="text-align:center;">
              <!-- <img v-bind:src="style_details.style_image" id="map" height="220" width="270" style="padding:5px;" /> -->
              <div>
                <img
                  v-bind:src="image_model"
                  id="map"
                  height="220"
                  width="270"
                  style="padding:5px;"
                />
              </div>
              <a :href="image_model" download
                ><i class="fa fa-download" aria-hidden="true"></i> Download</a
              >

              <div id="btn_navbar" class="mt-2">
                <!-- <button type="button" class="btn btn-success">
                  <a :href="image_model" download>
                    <i class="fa fa-download" aria-hidden="true"></i>Download</a
                  ></button
                >&nbsp; -->

                <!-- <button
                  type="button"
                  class="btn btn-success"
                  id="downloadimageid"
                >
                  <a
                    :href="image_model"
                    download
                    style="color:white; margin:-2px;"
                  >
                    <i class="fa fa-download" aria-hidden="true"></i
                    >&nbsp;Download</a
                  ></button
                >&nbsp; -->
                <button type="button" class="btn btn-success" @click="zoomin()">
                  <i class="fa fa-search-plus" aria-hidden="true"
                    >&nbsp;Zoom In</i
                  ></button
                >&nbsp;
                <button type="button" class="btn btn-danger" @click="zoomout()">
                  <i class="fa fa-search-minus" aria-hidden="true"
                    >&nbsp;Zoom Out</i
                  >
                </button>
              </div>
            </div>

            <div slot="footer" class="text-right">
              <!--  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button> -->
              <b-button size="sm" variant="danger" @click="openimagecancel()"
                >cancel</b-button
              >
            </div>
          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
          </template>
        </b-modal>
        <!-- Image Zoom Model -->

        <!-- SHiw Invalid inspection records starts showInspectionInvalidRecords -->
        <b-modal 
          id="modal-lg"
          size="xl"
          title="Invalid Inspection Records"
          v-model="showInspectionInvalidRecords"
          @ok="showInspectionInvalidRecords = false"
        >

        <template #modal-title>
          <div >
            <span>Invalid Inspection Records</span>
            <b-button variant="primary" style="margin-left: 800px;" @click="downloadInvalidrecordsData()">
              Download
            </b-button>
            <!-- <b-button type="button" class="ml-2" variant="danger" @click="closeInspectionInvalidRecords();">
              Close
            </b-button> -->
          </div>
        </template>
          <span style="color:red;">ERROR</span>
 
          <b-table 
            striped 
            hover 
            :items="invalidrecords"
            :bordered="true"
            :fields="invalidrecords_fields"
            class="table-responsive mt-3">

              <template slot="err" slot-scope="row">
                {{row.item.errors.join(', ') }}
              </template>

          </b-table>

             <!-- <b-button class="ml-2" variant="danger" @click="closeInspectionInvalidRecords();">
              Close
            </b-button> -->

        </b-modal>


    </b-row>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import auth from "@/utils/auth";
import Vue from "vue";
import Utils from "@/utils";
import { ToggleButton } from "vue-js-toggle-button";
import Datepicker from "vuejs-datepicker";
Vue.component("ToggleButton", ToggleButton);
// import auth from "@/utils/auth";

import sidebarSettingsComponent from "./_sidebarSettingsComponent.vue";
import Table from "../views/base/Table.vue";

const axios = require("axios");
export default {
  name: "Tabs",
  components: {
    sidebarSettingsComponent,
    Table,
    Datepicker,
  },
  data() {
    return {
      tabs: ["Calculator", "Shopping cart", "Charts"],

      inspection_qcname: [],
      vendor_search_name: [],
      buyer_search_name: [],
      qc_list: [],
      brand_list:[],
      qc_listt: { text: "text", value: "value" },
      vendor_list: [],
      vendor_listt: { text: "text" },
      buyer_list: [],
      buyer_listt: { text: "text" },

      DatePickerFormat: "dd/MM/yyyy",
      disabledDates: {
        to: new Date(Date.now() - 8640000),
      },
      qc_name: "",
      brand_name:"",
      full_name: [],
      location: null,
      seachdata:[],
      inspectionStatus: null,
      inspectionzone: null,
      inspectionStyleType:null,
      uploaded_inspection_type: null,
      style_details: [],
      design_file_list: [],
      catselected: "",
      subcatselected: "",
      cat_title: "",
      sub_cat_title: "",
      created_date: "",
      title: "",
      id: 0,
      design_no: "",
      no: 0,
      perPage: 10,
      currentPage: 1,
      pageNo: 1,
      noofpages: 0,
      approvedcount: 0,
      col_id: 0,
      imgpath: "",
      totalRows: 0,
      visible: true,
      list: [],
      user_id: 0,
      messagedata: [],
      selectedId: 0,
      txtInput: "",
      selected: "",
      customer: {},
      user_result: [],
      inspection_length: "",
      comment_details: [],
      image_details: [],
      list_totalRows: "",

      selectedDate: new Date(),
      items: [],
      result: [],
      img_result: [],
      userdetails: [],
      actionforapproveqc: "",
      isCheckAll: false,
      user_id: "",
      assigned_sub_cat_id: [],
      design_details: [],
      allocate_inspection: false,
      markasholdmodal: false,
      assign_qc: false,
      changeprofile: false,
      uploadphoto: false,
      file: "",
      arr: [],
      img_path: "",
      avatar: null,
      image: "",
      items: [1],
      activeTab: 1,
      selectedFile: null,
      remoteUrl: "",
      image1: {},
      isToggled: false,
      selected_brand_id: 0,
      dh_status: false,
      dh_avaliable_status: 0,
      user_type: "",
      approve_status: 0,
      assign_qc_name: "",
      inspection_id: "",

      openimagemodel: false,
      image_model: "",
      inspection_checked: [],
      checked_values: [],
      inspection_checkedList: [],
      //progressBar
      selectedFiles: "",
      currentFile: "",
      progress: 0,
      message: "",
      inspection_date: "",
      inspection_to_date: "",
      inspection_data: [],
      uploadfilemodel: false,
      brand_model: false,
      id: "",

      selected_inspection_data: {},
      qc_name_arr: [],
      brand_name_arr:[],
      buyer_name_arr: [],
      vendor_name_arr: [],
      selected_qc_id: "",
      selected_brandID:"",
      selected_brand_name:"",
      

      inspection_fields: [
        { key: "checkbox", label: "Select" },
        { key: "stylcode", label: "Style Code" },
        { key: "showDate", label: "Inspection Date" },
        { key: "loc", label: "Location & Zone" },
        { key: "createdslot", label: "Created By" },
        { key: "buyer_name", label: "Buyer Name" },
        { key: "vendor_name", label: "Vendor Name" },
        { key: "offeredquantityslot", label: "Offered Quantity" },
        { key: "inspection_type", label: "Inspection Type" },
        // { key: "zone", label: "Zone" },
        { key: "allocate_to", label: "Inspection Assigned" },
        { key: "inpection_uploaded_satus", label: "Uploaded Inspection" },
        { key: "style_type",label: "Style Type" },
        { key: "inspection_status", label: "Status" },
        { key: "protoactions", label: "Action" },
      ],

      options: [
        { value: "Amol", text: "Amol" },
        { value: "Sudama", text: "Sudama" },
        { value: "Jeet", text: "Jeet" },
        { value: "Suresh", text: "Suresh" },
      ],

      options2: [
        { value: "Approved", text: "Approved" },
        { value: "Reject", text: "Reject" },
      ],

      options1: [
        { value: null, text: "Select Zone" },
        { value: "East", text: "East" },
        { value: "West", text: "West" },
        { value: "North", text: "North" },
        { value: "South", text: "South" },
      ],

      options3: [
        { value: null, text: "Select Location" },
        { value: "Delhi", text: "Delhi" },
        { value: "Ludhiana", text: "Ludhiana" },
        { value: "Mumbai", text: "Mumbai" },
        { value: "Jaipur", text: "Jaipur" },
        { value: "Kolkata", text: "Kolkata" },
        { value: "New delhi", text: "New delhi" },
        { value: "Tirupur", text: "Tirupur" },
        { value: "Bangalore", text: "Bangalore" },
        { value: "Lahuri", text: "Lahuri" },
      ],

      options4: [
        { value: null, text: "Uploaded Inspection Type" },
        { value: "Direct", text: "System" },
        { value: "Manual", text: "Manual" },
        { value: "Runtime", text: "Runtime" },
        { value: "Video", text: "Video"}
      ],

      options5: [
        { value: null, text: "Inspection Status" },
        { value: "Pending", text: "Pending" },
        { value: "Scheduled", text: "Scheduled" },
        { value: "Hold", text: "Hold" },
        { value: "RFT", text: "RFT" },
        { value: "RC", text: "RC" },
        { value: "2nd Pass", text: "2nd Pass" },
        { value: "Reject", text: "Reject" },
        { value: "Other", text: "Other" },
        { value: "Carry Forward", text: "Carry Forward" },
        { value: "Cancel", text: "Cancel" },
        { value: "Approved", text: "Approved" },
      ],
      // fileInfos:[]

      serverTime: null,
      isUploadDisabled: false,
      extracted_date: "",
      rejectedRecords: [],
      page: "",
      route_status: "",
      Obj: {},
      Object: {},
      brandID:'',
      brandName :'',
      selectedInspectionIDForHold:'',
      dataFound: false,
      options6: [
        { value: null, text: "Select Style Type" },
        { value: "apparel", text: "Apparel" },
        { value: "footwear", text: "Footwear" },
      ],
      inspectionInvalidRecords:[],
      showinspectionInvalidRecords: false,
      invalidrecords:[],
      invalidrecords_fields:[
      { key: "STYLE NO", label: "STYLE NO" },
      { key: "err", label: "ERROE MESSAGE " },
      { key: "STYLE TYPE", label: "STYLE TYPE" },
      { key: "ZONE", label: "ZONE" },
      { key: "VENDOR CODE", label: "VENDOR CODE" },
      { key: "VENDOR", label: "VENDOR" },
      { key: "TOTAL ORDER QNTY", label: "TOTAL ORDER QNTY" },
      { key: "SEASON", label: "SEASON" },
      { key: "PRODUCT DESCRIPTION", label: "PRODUCT DESCRIPTION" },
      { key: "PO Number", label: "PO Number" },
      { key: "OFFER QNTY", label: "OFFER QNTY" },
      { key: "M.R.P", label: "M.R.P" },
      { key: "LOCATION", label: "LOCATION" },
      { key: "INSPECTION TYPE", label: "INSPECTION TYPE" },
      { key: "INSPECTION DATE", label: "INSPECTION DATE" },
      { key: "COLOUR", label: "COLOUR" },
      ],
      invalidIdOfRecords:[],
    };
  },

    created: function() {
    // this.getusersdetails();
    this.getinspectionlisting(1);
    this.getqcuser_name();
    this.getBuyer_name();
    this.getVendor_name();
    this.route_status = "";
    this.id = this.$route.params.id;
    this.no = this.$route.params.no;
    this.col_id = this.$route.params.col_id;
    // var userData = localStorage.getItem("userData");
    // var userInfo = JSON.parse(userData);
    // this.user_type = userInfo[0].user_type;
    // alert(this.route_status);
  },
  mounted() {
    var userData = localStorage.getItem("userData");
    var userInfo = JSON.parse(userData);
    this.user_type = userInfo[0].user_type;
  },

  methods: {

        removeImage: function(e) {
      this.remoteUrl = "";
    },

    markasholdfun:function(value){
      console.log(value)
      this.selectedInspectionIDForHold = value;
      this.markasholdmodal= ! this.markasholdmodal;
    },

    submitmarkasholdmodal:function(){
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      
      const obj={
        inspection_id: this.selectedInspectionIDForHold,
        inspection_status: "Hold",
         login_userid: userInfo[0].user_id
      }

       axios
        .post(`${CONSTANTS.API_URL}/updateInspectionStatusToHoldForcefully `, obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";

          if (response.data.returnmsg === "Successful") {
            this.$fire({
              text: "Inspection Selected as hold",
              type: "success",
              timer: 30000,
            });
            this.markasholdmodal= ! this.markasholdmodal;
             (this.inspectionzone = ""); 
             (this.inspectionStyleType = "");
            (this.location = "");
            this.seachdata = [];
            (this.inspectionStatus = "");
            (this.uploaded_inspection_type = "");
            this.inspection_date = "";
            this.inspection_to_date = "";
            this.inspection_qcname = [];
            this.buyer_search_name = [];
            this.vendor_search_name = [];
            this.getinspectionlisting(1);
          } else {
            this.$fire({
              text: response.data.returnvalue,
              type: "error",
              timer: 30000,
            });
            this.markasholdmodal= ! this.markasholdmodal;
            this.getinspectionlisting(1);
          }
        })

        .catch((e) => {
          this.errors.push(e);
        });
    },

    editinfoModal: function(value) {
      // console.log("fFFFFFFFFFFFFFFFFFFFFFFFFFF", value)
      (this.selected_inspection_data = value),
        (this.inspection_id = value.inspection_id),
        (this.allocate_inspection = !this.allocate_inspection);
      // this.getdesigndetail();
      this.getqcuser_name();
      // this.getinspectionlisting();
      this.getinspectioncomment();
      this.getinspectionimages();
    },

    uploadfilemodelfunction: function() {
      document.getElementById("overlay").style.display = "block";
      this.invalidIdOfRecords =[]
      
      const obj={}

       axios
        .post(`${CONSTANTS.API_URL}/validateInspectionTime `, obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";

          if (response.data.returnmsg === "Successful") {

            this.uploadfilemodel = true;
            this.selected_brandID = "";
          }

          else{
              this.$fire({
              text: response.data.returnmsg,
              type: "error",
              timer: 30000,
            });
          }
        })

      
    },

    selectFile(event) {
      this.selectedFiles = event.target.files[0];
      this.imgname = this.selectedFiles.name;
      console.log(
        this.selectedFiles,
        "selectedFilesselectedFilesselectedFiles"
      );
    },

    validateForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.csvFilesUpload(scope);
        }
      });
    },

    validateForm2(scope){
    
      if (this.selected_brandID.length != 0 ) {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.brand_model = false;
            document.getElementById("staicuploadfile").style.display = "none";
            document.getElementById("dynamicuploadfile").style.display = "block";

            var tempname = this.selected_brandID.split("-");
            this.brandID = tempname[0]
            this.brandName = tempname[1]
            // console.log(name, name1);
            this.selected_brandID = "";

          }
        });
      } else {
        this.$fire({
          text: "Please Select Brand Name",
          type: "error",
          timer: 30000,
        });
         this.selected_brandID = "";

      }


      //  this.$validator.validateAll(scope).then((result) => {
      //   if (result) {
      //     alert(this.selected_brandID);
      //   }
      // });

    },



    csvFilesUpload() {
      document.getElementById("progress_bar").style.display = "block";
      document.getElementById("overlay").style.display = "block";

      // return false;
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      this.progress = 0;

      let data = new FormData();
      data.append("file", this.selectedFiles);
      data.append("file", this.imgname);
      console.log(this.imgname, "this.imgname");
      data.append("createdby", userInfo[0].user_id);
      data.append("user_type", userInfo[0].user_type);
      data.append("brand_title", this.brandName);
      data.append("brand_id", this.brandID);
      console.log(userInfo[0].email_id, "createdby");

      console.log(data, "data data data data ");
      axios
        .post(`${CONSTANTS.API_URL}/uploadInspectionCSVManually`, data, {
          header: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function(progressEvent) {
            this.progress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
          }.bind(this),
        })
        .then((response) => {
          //  alert("innnn");
          this.progress = Math.round((100 * response.loaded) / response.total);
          document.getElementById("overlay").style.display = "none";
          console.log("Responseeeeeeeeee", response);
          console.log("response.data.acceptedrecords", response.data.acceptedrecords)
          console.log("response.data.invalidrecords",response.data.invalidrecords);
            // Unsuccessful
          if (response.data.returnmsg === 'Unsuccessful'){
              if (response.data.invalidrecords == undefined && response.data.acceptedRecords.length == 0) {
                // For the first response type: Show error message and reset the modal and listing.
                this.$fire({
                  text: response.data.returnvalue,
                  type: "error",
                  timer: 30000,
                });

                this.uploadfilemodel = false;
                this.getinspectionlisting(this.pageNo);
                this.getqcuser_name();

              } else if (response.data.invalidrecords != undefined && response.data.acceptedrecords.length == 0) {
                // For the second response type: Show invalid records details and reset the modal.
                this.showInspectionInvalidRecords = true;
                this.inspectionInvalidRecords = response.data.returnvalue;
                this.invalidrecords = response.data.invalidrecords;
                this.invalidIdOfRecords = response.data.updatedrecords;
                this.uploadfilemodel = false;
                
                this.getinspectionlisting(this.pageNo);
                this.getqcuser_name();
              }
          }

          else if(response.data.returnmsg === "Successful" && response.data.invalidrecords.length > 0 && response.data.acceptedrecords.length > 0){
            this.inspectionInvalidRecords = response.data.returnvalue
            this.invalidrecords = response.data.invalidrecords
            this.invalidIdOfRecords = response.data.updatedrecords
            this.uploadfilemodel = false;
            this.showInspectionInvalidRecords = true;
            this.getinspectionlisting(this.pageNo);
            this.getqcuser_name();

          }

          else if (response.data.returnmsg === "Successful" && response.data.acceptedrecords.length > 0) 
            {
            // alert(" File Added Successfully.");
            this.$fire({
              text: "File Uploaded Successfully",
              type: "success",
              timer: 30000,
            });
            document.getElementById("progress_bar").style.display = "none";

            this.uploadfilemodel = false;
            this.getinspectionlisting(this.pageNo);
            this.getqcuser_name();
          } 

          else if (response.data.returnmsg === "Successful" && response.data.RejectedOrDuplicateRecords.length > 0  && response.data.acceptedrecords.length == 0)
          {
            let temparryrecord = [];
            for (
              let k = 0;
              k < response.data.RejectedOrDuplicateRecords.length;
              k++
            ) {
              temparryrecord.push(
                response.data.RejectedOrDuplicateRecords[k]["STYLE NO"]
              );
              
            }

            console.log("SSSSSSSSSSSSSS", temparryrecord);
            var str = "Following records are rejected";

            this.$fire({
              text: temparryrecord,
              title: "File Uploaded Successfully but no records are accepted",
              html: "<pre>" + str + "</pre>" + "" + temparryrecord + "",

              type: "success",

              timer: 30000,
            });
            document.getElementById("progress_bar").style.display = "none";

            this.uploadfilemodel = false;
            this.getinspectionlisting(this.pageNo);
            this.getqcuser_name();
          }

          else if (response.data.returnmsg === "Successful" && response.data.RejectedOrDuplicateRecords.length > 0) 
          {
            let temparryrecord = [];
            for (
              let k = 0;
              k < response.data.RejectedOrDuplicateRecords.length;
              k++
            ) {
              temparryrecord.push(
                response.data.RejectedOrDuplicateRecords[k]["STYLE NO"]
              );
              
            }

            console.log("SSSSSSSSSSSSSS", temparryrecord);
            var str = "Following records are rejected";

            this.$fire({
              text: temparryrecord,
              title: "File Uploaded Successfully ",
              html: "<pre>" + str + "</pre>" + "" + temparryrecord + "",

              type: "success",

              timer: 30000,
            });
            document.getElementById("progress_bar").style.display = "none";

            this.uploadfilemodel = false;
            this.getinspectionlisting(this.pageNo);
            this.getqcuser_name();
          } 

          else {
            this.$fire({
              text: response.data.returnvalue,
              type: "error",
              timer: 30000,
            });

            this.uploadfilemodel = false;
            this.getinspectionlisting(this.pageNo);
            this.getqcuser_name();
          }

     
        });
    },

    getinspectionimages: function() {
      const Obj = {
        inspection_id: this.inspection_id,
      };

      axios
        .post(`${CONSTANTS.API_URL}/getinspectionimages `, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";

          if (response.data.returnmsg === "Successful") {
            this.image_details = response.data.returnvalue;
            console.log(this.image_details, "this.this.image_details");
          } else {
            this.image_details = [];
          }
        })

        .catch((e) => {
          this.errors.push(e);
        });
    },

    getinspectioncomment: function() {
      // alert(this.inspection_id );
      const Obj = {
        inspection_id: this.inspection_id,
      };

      axios
        .post(`${CONSTANTS.API_URL}/getinspectioncomment`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";

          if (response.data.returnmsg === "Successful") {
            this.comment_details = response.data.returnvalue;
            // console.log(this.comment_details[0].message,"this.comment_details")
          } else {
            this.comment_details = [];
          }
        })

        .catch((e) => {
          this.errors.push(e);
        });
    },

    openimage: function(img_path) {
      // alert(img_path);
      this.image_model = img_path;
      this.openimagemodel = true;
    },

    getbrand_mode(){
      this.brand_model = true;
       var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      const Obj = {
        login_userid: userInfo[0].user_id,
        user_type: userInfo[0].user_type
      };

      // alert("getqcuser_name")
      axios
        .post(`${CONSTANTS.API_URL}/getBrandListForBuyerForCMSManualUpload`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.brand_name_arr = this.result.returnvalue;
            this.brand_list = this.result.returnvalue;
          
            let temp_brand_list = [];
            this.result.returnvalue.map((item, index) => {
              let tempItem = {};
              (tempItem.text = item.brand_title),
                (tempItem.value = item.brand_id),
                temp_brand_list.push(tempItem);
            });

            this.brand_list = temp_brand_list;
            
          } 
          // else {
          //   this.$fire({
          //     text: this.result.returnmsg,
          //     type: "error",
          //     timer: 30000,
          //   });
          // }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    getqcuser_name: function() {
      const Obj = {};

      // alert("getqcuser_name")
      axios
        .post(`${CONSTANTS.API_URL}/qcuserlisting`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.qc_name_arr = this.result.returnvalue;
            this.qc_list = this.result.returnvalue;
            // console.log(this.qc_list);
            let temp_qc_list = [];
            this.result.returnvalue.map((item, index) => {
              let tempItem = {};
              (tempItem.text = item.full_name),
                (tempItem.value = item.user_id),
                temp_qc_list.push(tempItem);
            });

            this.qc_list = temp_qc_list;
            // console.log("QCQCQCQCQCQCQC")
            // console.log(this.qc_list);
          } else {
            this.$fire({
              text: this.result.returnmsg,
              type: "error",
              timer: 30000,
            });
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    getBuyer_name: function() {
      const Obj = {};

      // alert("getqcuser_name")
      axios
        .post(`${CONSTANTS.API_URL}/getAllDistinctBuyers`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.buyer_name_arr = this.result.returnvalue;
            this.buyer_list = this.result.returnvalue.full_name;
            // console.log(this.qc_list);
            let temp_buyer_list = [];
            this.result.returnvalue.map((item, index) => {
              let tempItem = {};
              (tempItem.text = item.full_name),
                // (tempItem.value = item.full_name),
                temp_buyer_list.push(tempItem);
            });

            this.buyer_list = temp_buyer_list;
            // console.log("QCQCQCQCQCQCQC")
            // console.log(this.qc_list);
          } else {
            this.$fire({
              text: this.result.returnmsg,
              type: "error",
              timer: 30000,
            });
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    getVendor_name: function() {
      const Obj = {};

      // alert("getqcuser_name")
      axios
        .post(`${CONSTANTS.API_URL}/getAllDistinctVendors`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.vendor_name_arr = this.result.returnvalue;
            this.vendor_list = this.result.returnvalue.vendor_name;
            // console.log(this.qc_list);
            let temp_vendor_list = [];
            this.result.returnvalue.map((item, index) => {
              let tempItem = {};
              (tempItem.text = item.vendor_name),
                // (tempItem.value = item.vendor_id),
                temp_vendor_list.push(tempItem);
            });

            this.vendor_list = temp_vendor_list;
            // console.log("QCQCQCQCQCQCQC")
            // console.log(this.qc_list);
          } else {
            this.$fire({
              text: this.result.returnmsg,
              type: "error",
              timer: 30000,
            });
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    validateForm6(scope) {
      if (this.selected_qc_id.length != 0 && this.checked_values.length != 0) {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.send_MultipleInspection_to_qc();
          }
        });
      } else {
        this.$fire({
          text: "Please Select QC name and atleast one inspection",
          type: "error",
          timer: 30000,
        });
      }
    },

    send_MultipleInspection_to_qc: function() {
      const Obj = {
        user_id: this.selected_qc_id,
        inspection_id: this.checked_values,
      };

      console.log(Obj, "Obj");

      console.log("Obj", Obj);
      axios
        .post(`${CONSTANTS.API_URL}/assigninspectiontoqcuser`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.$fire({
              text: "Inspection Allocated Successfully",
              type: "success",
              timer: 30000,
            });
            this.getinspectionlisting(this.pageNo);
            this.getqcuser_name();
            this.isCheckAll = false;
            this.checked_values = [];
          } else {
            this.$fire({
              text: this.result.returnmsg,
              type: "error",
              timer: 30000,
            });
            this.getinspectionlisting(this.pageNo);
            this.getqcuser_name();
            // this.isCheckAll = false;
          }
        })

        .catch((e) => {
          this.errors.push(e);
        });
    },

    validateForm5(scope) {
      if (this.selected_qc_id.length != 0) {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.send_inspection_to_qc();
          }
        });
      } else {
        this.$fire({
          text: "Please Select QC name",
          type: "error",
          timer: 30000,
        });
      }
    },

    send_inspection_to_qc: function() {
      // console.log(this.selected_qc_id)
      let temoArr = [];
      temoArr.push(this.inspection_id);
      const Obj = {
        user_id: this.selected_qc_id,
        inspection_id: temoArr,
      };

      axios
        .post(`${CONSTANTS.API_URL}/assigninspectiontoqcuser`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.$fire({
              text: "Inspection Allocated Successfully",
              type: "success",
              timer: 30000,
            });
            this.allocate_inspection = !this.allocate_inspection;
            this.getinspectionlisting(pageNo);
          } else {
            this.$fire({
              text: this.result.returnmsg,
              type: "error",
              timer: 30000,
            });
          }
        })

        .catch((e) => {
          this.errors.push(e);
        });
      this.getinspectionlisting(pageNo);
    },

    getapprovedInspectiondownload: function() {
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      var user_type = userInfo[0].user_type;
      const Obj = {
        login_userid: userInfo[0].user_id,
        user_type: user_type,
      };

      axios
        .post(`${CONSTANTS.API_URL}/getapprovedInspectiondownload`, Obj)
        .then((response) => {
          // console.log(response);
          this.downloadHelper(response.data);
        });
    },

    getaAllInspectiondownload: function() {
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      var user_type = userInfo[0].user_type;

      let tempsearchdata = this.seachdata.toString().split(",");
      if (this.route_status == " ") {
        this.Object = {
          pageno: this.pageNo,
          pagesize: this.perPage,
          vendor_search_name: this.vendor_search_name,
          buyer_search_name: this.buyer_search_name,
          inspection_qcname: this.inspection_qcname,
          inspection_date: this.inspection_date,
          inspection_to_date: this.inspection_to_date,
          inspectionzone: this.inspectionzone,
          inspectionStyleType: this.inspectionStyleType,
          location: this.location,
          search_text:tempsearchdata,
          inspectionStatus: this.inspectionStatus,
          uploaded_inspection_type: this.uploaded_inspection_type,
          user_type: user_type,
          login_userid: userInfo[0].user_id,
          // inspectionstatus: this.route_status,
        };
      } else {
        this.Object = {
          pageno: this.pageNo,
          pagesize: this.perPage,
          vendor_search_name: this.vendor_search_name,
          buyer_search_name: this.buyer_search_name,
          inspection_qcname: this.inspection_qcname,
          inspection_date: this.inspection_date,
          inspection_to_date: this.inspection_to_date,
          inspectionzone: this.inspectionzone,
          inspectionStyleType: this.inspectionStyleType,
          location: this.location,
          search_text: tempsearchdata,
          inspectionStatus: this.route_status,
          uploaded_inspection_type: this.uploaded_inspection_type,
          user_type: user_type,
          login_userid: userInfo[0].user_id,
        };
      }

      axios
        .post(`${CONSTANTS.API_URL}/getinspectioncsv`, this.Object)
        .then((response) => {
          if(response.data.returnmsg=='Unsuccessful'){
            if(response.data.returnvalue=='data not found'){
              this.$fire({
                text: "No data available for download!",
                type: "info",
                timer: 30000,
              });
            }else{
              this.$fire({
                text: "Error in downloading data!",
                type: "error",
                timer: 30000,
              });
            }
          }else{
            // console.log(response.data);
            this.downloadHelper(response.data);
          }
        });
    },

    downloadfilemodelfunction: function(value) {
      // alert(value);
      downloadHelper(fs.readFileSync(value));
      // this.downloadHelper(data)
    },

    downloadHelper(csv) {
      var downloadLink = document.createElement("a");
      var blob = new Blob(["\ufeff", csv]);
      var url = URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = "Data.csv";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },

    updateprofile: function() {
      document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");

      var userInfo = JSON.parse(userData);

      const Obj = {
        full_name: `${this.customer.full_name}`,
        email_id: `${this.customer.email_id}`,
        contact_no: `${this.customer.contact_no}`,
        role: `${this.customer.role}`,
        user_id: userInfo[0].user_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/updateuserprofile`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            // Utils.notify("Updated Successfully", "success");
            this.$fire({
              text: "Updated Successfully",
              type: "success",
              timer: 30000,
            });
            this.changeprofile = !this.changeprofile;
            this.customer = {};
            this.getusersdetails();

            // this.getdesignsummary(this.id);
          } else {
            // alert(this.result.returnmsg);
            this.$fire({
              text: this.result.returnmsg,
              type: "error",
              timer: 30000,
            });

            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
      //}
    },

    // FOR SEARCH ON HEADER FOR INSPECTION

    validateForm3(scope) {
      // alert(scope);
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          if (this.inspection_date > this.inspection_to_date) {
            // alert()
            this.$fire({
              text: "Please select To date greater than From date",
              type: "error",
              timer: 30000,
            });
          } else {
            this.searchinspectiondata(1);
          }
        }
      });
    },

    clickCallback(pageNo) {
      //   alert(" i m in pagination task");
      // alert(this.inspectionzone);
      if (
        this.inspection_qcname.length > 0 ||
        this.buyer_search_name.length > 0 ||
        this.vendor_search_name.length > 0 ||
        (this.inspection_date != null && this.inspection_date != "") ||
        (this.inspection_to_date != null && this.inspection_to_date != "") ||
        (this.location != null && this.location != "") ||
        (this.seachdata.length > 0) ||
        (this.inspectionStatus != null && this.inspectionStatus != "") ||
        (this.uploaded_inspection_type != null &&
          this.uploaded_inspection_type != "") ||
        (this.inspectionzone != null && this.inspectionzone != "")||
        (this.inspectionStyleType !=null && this.inspectionStyleType != "")
      ) {
        this.searchinspectiondata(pageNo);
      } else {
        this.getinspectionlisting(pageNo);
      }
    },

    searchinspectiondata: function(pageNo) {
      
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      var buyer_id = userInfo[0].user_id;
      var user_type = userInfo[0].user_type;

      let tempsearchdata = this.seachdata.toString().split(",");
      console.log(tempsearchdata,"lLLLLLLLLLLLL");

      const myArr = this.$route.params.id
        ? this.$route.params.id.split(",")
        : " ";
      console.log("Myarr", myArr);
      this.route_status = myArr[0];
      console.log("HHHHHH", this.route_status);
      if (this.route_status == " ") {
        this.Obj = {
          pageno: pageNo,
          pagesize: this.perPage,
          vendor_search_name: this.vendor_search_name,
          buyer_search_name: this.buyer_search_name,
          inspection_qcname: this.inspection_qcname,
          inspection_date: this.inspection_date,
          inspection_to_date: this.inspection_to_date,
          inspectionzone: this.inspectionzone,
          inspectionStyleType: this.inspectionStyleType,
          location: this.location,
          search_text: tempsearchdata,
          inspectionStatus: this.inspectionStatus,
          uploaded_inspection_type: this.uploaded_inspection_type,
          user_type: user_type,
          login_userid: userInfo[0].user_id,
          // inspectionstatus: this.route_status,
        };
      } else {
        this.Obj = {
          pageno: pageNo,
          pagesize: this.perPage,
          vendor_search_name: this.vendor_search_name,
          buyer_search_name: this.buyer_search_name,
          inspection_qcname: this.inspection_qcname,
          inspection_date: this.inspection_date,
          inspection_to_date: this.inspection_to_date,
          inspectionzone: this.inspectionzone,
          inspectionStyleType: this.inspectionStyleType,
          location: this.location,
          search_text: tempsearchdata,
          inspectionStatus: this.route_status,
          uploaded_inspection_type: this.uploaded_inspection_type,
          user_type: user_type,
          login_userid: userInfo[0].user_id,
        };
      }
      axios
        .post(`${CONSTANTS.API_URL}/getsearchinspection`, this.Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          // JSON responses are automatically parsed.

          this.quotationlistModel = true;
          this.page = pageNo;
          if (response.data.returnmsg == "Successful") {
            console.log("correct");
            this.inspection_data = response.data.returnvalue;
  
            this.list_totalRows = response.data.totalcount;
            this.noofpages = parseInt(this.list_totalRows) / 10;

            this.noofpages = Math.ceil(this.noofpages);
            this.totalRows = this.inspection_data.length;
      

            for (var i = 0; i < this.inspection_data.length; i++) {
              var vendoryagent2 = {
                id: this.inspection_data[i].inspection_id,
              };
              this.inspection_checkedList.push(
                this.inspection_data[i].inspection_id
              );

              if (
                this.isCheckAll &&
                (this.inspection_data[i].inspection_status == "Approved" ||
                  this.inspection_data[i].inspection_status ==  "Carry Forward" ||
                  this.inspection_data[i].inspection_status == "Pending" ||
                  this.inspection_data[i].inspection_status == "Scheduled" ||
                  this.inspection_data[i].inspection_status == "Cancel")
              ) {
                this.checked_values.push(this.inspection_data[i].inspection_id);
              }

              if (
                this.inspection_data[i].inspection_status == "Approved" ||
                this.inspection_data[i].inspection_status ==  "Carry Forward" ||
                this.inspection_data[i].inspection_status == "Pending" ||
                this.inspection_data[i].inspection_status == "Scheduled" ||
                this.inspection_data[i].inspection_status == "Cancel"
              ) {
                this.approvedcount++;
              }
            }

            // for (let j = 0; j < this.inspection_data.length; j++) {
            //   var onlydate = this.inspection_data[j].inspection_date;
            //   this.extracted_date = onlydate.split("T")[0];
            //   console.log("FFFFFFFFFFF", this.extracted_date);
            // }

            this.isBusy = !this.isBusy;
            this.approvedcount = 0;

            // console.log(this.inspection_data.length,"%%%%%%%%%%%%");
          } else {
            
            this.$fire({
              text: "No Data Found",
              type: "warning",
              timer: 30000,
            });
            this.list_totalRows = response.data.totalcount;
            (this.inspection_data = []), (this.isBusy = false);
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((err) => {
          this.errors.push(e);
        });
    },

    // FOR SEARCH ON HEADER FOR INSPECTION -- ENDS

    // Approve or reject action code in allocate inspection tab

    validateForm4(scope) {
      // alert(scope);
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.approveqcdeatils();
        }
      });
    },

    approveqcdeatils() {
      //  console.log(this.actionforapproveqc)
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      var buyer_id = userInfo[0].user_id;

      const Obj = {
        buyer_id: userInfo[0].user_id,
        style_id: this.$route.params.id,
        inspection_id: this.inspection_id,
        action: this.actionforapproveqc,
      };

      axios
        .post(`${CONSTANTS.API_URL}/buyerapproveinspectionreq`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          // JSON responses are automatically parsed.
          this.result = response.data;
          this.quotationlistModel = true;
          if (this.result.returnmsg === "Successful") {
            this.$fire({
              text: "Approved Inspection",
              type: "success",
              timer: 30000,
            });
            this.allocate_inspection = !this.allocate_inspection;
            this.getinspectionlisting(pageNo);
          } else {
            this.errors.push(e);
          }
        });
    },

    /****** Function to design details ********/
    getdesigndetail: function() {
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      this.access_token = userInfo[0]["token"];
      axios.defaults.headers.common["x-access-token"] = this.access_token;
      axios.defaults.headers.common["Content-Type"] =
        "application/json;charset=UTF-8";
      axios.defaults.headers.common["Accept"] = "application/json";
      axios.defaults.headers.common["Origin"] = "http://localhost:8080";
      this.isBusy = true;

      const Obj = {
        style_id: this.$route.params.id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getdesigndetail`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.style_details = this.result.returnvalue[0];
          } else {
            this.style_details = [];

            this.isBusy = !this.isBusy;
          }
        });
      // .catch(e => {
      //   this.errors.push(e)
      // })
    },

    // For Inspection list api's

    getinspectionlisting: function(pageNo) {
      this.inspection_checkedList = [];

      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      var buyer_id = userInfo[0].user_id;
      var user_type = userInfo[0].user_type;
      console.log("this.$route.params.id@@@@@@@@@@@@@@@@@@@@@@" ,this.$route.params.id)
      ///const myArr 
      if(this.$route.params.id==undefined || this.$route.params.id=='' || this.$route.params.id==null){
          //  const myArr=null
           this.route_status  = null
      }else{
        this.route_status=this.$route.params.id.toString()
        // this.route_status = myArr[0;
      }
      ///const myArr = this.$route.params.id ? this.$route.params.id : '';
      // console.log("Myarr", myArr);
      // this.route_status = myArr[0];
      // console.log("HHHHHH", this.route_status);

      const Obj = {
        pageno: pageNo,
        pagesize: this.perPage,
        user_type: user_type,
        buyer_id: userInfo[0].user_id,
        inspectionstatus: this.route_status,
      };

      this.page = pageNo;


      axios
        .post(`${CONSTANTS.API_URL}/getinspectionlisting`, Obj)
        .then((response) => {
          // console.log(response.data.returnvalue)
          if (response.data.returnmsg == "Successful") {
            this.dataFound = true
            // console.log(response.data.returnvalue)
            this.inspection_data = response.data.returnvalue;

            for (var i = 0; i < this.inspection_data.length; i++) {
              var vendoryagent2 = {
                id: this.inspection_data[i].inspection_id,
              };
              this.inspection_checkedList.push(
                this.inspection_data[i].inspection_id
              );

              if (
                this.isCheckAll &&
                (this.inspection_data[i].inspection_status == "Approved" ||
                  this.inspection_data[i].inspection_status ==  "Carry Forward" ||
                  this.inspection_data[i].inspection_status == "Pending" ||
                  this.inspection_data[i].inspection_status == "Scheduled" ||
                  this.inspection_data[i].inspection_status == "Cancel")
              ) {
                this.checked_values.push(this.inspection_data[i].inspection_id);
              }

              if (
                this.inspection_data[i].inspection_status == "Approved" ||
                this.inspection_data[i].inspection_status ==  "Carry Forward" ||
                this.inspection_data[i].inspection_status == "Pending" ||
                this.inspection_data[i].inspection_status == "Scheduled" ||
                this.inspection_data[i].inspection_status == "Cancel"
              ) {
                this.approvedcount++;
              }
            }

            // for (let j = 0; j < this.inspection_data.length; j++) {
            //   var onlydate = this.inspection_data[j].inspection_date;
            //   this.extracted_date = onlydate.split("T")[0];
            //   console.log("FFFFFFFFFFF", this.extracted_date);
            // }

            this.list_totalRows = response.data.totalcount;

            this.noofpages = parseInt(this.list_totalRows) / 10;

            this.noofpages = Math.ceil(this.noofpages);
            this.isBusy = !this.isBusy;

            this.approvedcount = 0;

            this.serverTime = response.data.Currenttime;
            // this.serverTime = new Date("2023-04-22:12:00:00");

            if (this.serverTime != null) {
              // let serverDate = new Date("2023-04-26:10:00:00")
              let serverDate = this.serverTime;
              let currentDay = serverDate.getDay();
              let currentTime = serverDate.getHours();

              if (
                (currentDay == 6 && currentTime > 11) ||
                currentDay == 0 ||
                (currentDay == 1 && currentTime < 9)
              ) {
                console.log("in condition");
                this.isUploadDisabled = true;
              }

              console.log("Servertime--------------------------->");
              console.log(currentDay);
              console.log(currentTime);
            } else {
              console.log("serverTime is null");
              this.isUploadDisabled = true;
            }

            // this.buyer_list = response.data.returnvalue;

            // let temp_vendor_list = [];
            // let temp_buyer_list = [];

            // response.data.returnvalue.map((item, index) => {
            //   let tempVBitem = {
            //     text: item.vendor_name,
            //     value: item.vendor_id,
            //   };

            //   let flag = false;
            //   for (let vendor of temp_vendor_list) {
            //     if (vendor.value == tempVBitem.value) {
            //       flag = true;
            //     }

            //   }

            //   if (flag != true) {
            //     temp_vendor_list.push(tempVBitem);
            //     console.log("@@@@@@@@@@@@@@@@@@", temp_vendor_list);
            //   }

            //   let tempBitem = {
            //     text: item.buyer_name,
            //     value: item.buyer_id,
            //   };

            //   let flag2 = false;
            //   for (let buyer of temp_buyer_list) {
            //     if (buyer.value == tempBitem.value) {
            //       flag2 = true;
            //     }
            //   }
            //   if (flag2 != true) {
            //     temp_buyer_list.push(tempBitem);
            //     console.log("&&&&&&&&&&&&&", temp_buyer_list);
            //   }
            // });

            // this.buyer_list = temp_buyer_list;
            // this.vendor_list = temp_vendor_list;

            this.totalRows = this.inspection_data.length;
          } else {
            this.$fire({
              text: "No Data Found",
              type: "warning",
              timer: 30000,
            });
            (this.inspection_data = []), (this.isBusy = false);
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((err) => {
          this.errors.push(err);
        });
    },

    // End of inspection API's

    //function to get users details
    getusersdetails: function() {
      // alert("In")
      // document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      this.access_token = userInfo[0]["token"];
      axios.defaults.headers.common["x-access-token"] = this.access_token;
      axios.defaults.headers.common["Content-Type"] =
        "application/json;charset=UTF-8";
      axios.defaults.headers.common["Accept"] = "application/json";
      axios.defaults.headers.common["Origin"] = "http://localhost:8080";

      const Obj = {
        user_id: userInfo[0].user_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getloginuserdetails`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          // console.log("LLLLLLLLLLLLLLL",this.result)
          if (this.result.returnmsg === "Successful") {
            // console.log("LLLLLLLLLLLLLLL",this.result.returnvalue)
            this.user_result = this.result.returnvalue;
            this.assigned_sub_cat_id = this.user_result[0].subcat_assign;
            this.selected_brand_id = this.user_result[0].brand_assign;
            this.remoteUrl = this.user_result[0].profile_image;
            this.customer = {};
            this.dh_avaliable_status = this.user_result[0].is_dh_available;
            if (this.dh_avaliable_status == 0) {
              this.dh_status = true;
            } else {
              this.dh_status = false;
            }
            // this.getdesignsummary(this.id);
          } else {
            this.user_result = [];

            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    editcancel: function() {
      this.customer = {};
      this.allocate_inspection = !this.allocate_inspection;
    },

    cancelmarkasholdmodal:function(){
      this.markasholdmodal = false;
    },
    

    assignqcmodel: function() {
      // alert()
      this.assign_qc = !this.assign_qc;
    },

    validateForm1(scope) {
      // alert(scope);
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.addqcname();
        }
      });
    },

    addqcname: function() {
      // console.log(this.assign_qc_name);
      this.$fire({
        text: "Thank You",
        type: "success",
        timer: 30000,
      });
      this.assign_qc = !this.assign_qc;
    },

    myRowClickHandler(record, index) {
      alert(index);
    },

    downloadOpenedImage: function(image_model) {
      alert(image_model);
      this.downloadHelperimage(image_model);
    },

    downloadHelperimage: function(url) {
      let name = image.split("/").pop();
      var downloadLink = document.createElement("a");
      var blob = new Blob(["\ufeff", image]);
      var url = URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = name;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },

    zoomin: function() {
      var myImg = document.getElementById("map");
      var currWidth = myImg.clientWidth;
      if (currWidth >= 680) return false;
      else {
        myImg.style.width = currWidth + 100 + "px";
      }
    },
    zoomout: function() {
      var myImg = document.getElementById("map");
      var currWidth = myImg.clientWidth;
      if (currWidth <= 270) return false;
      else {
        myImg.style.width = currWidth - 100 + "px";
      }
    },
    openimagecancel: function() {
      this.openimagemodel = !this.openimagemodel;
    },

    checkAll: function() {
      this.checked_values = [];
      this.isCheckAll = !this.isCheckAll;
      console.log(this.inspection_checkedList);
      if (this.isCheckAll) {
        // Check all
        for (var item of this.inspection_data) {
          if (
            item.inspection_status == "Approved" ||
            item.inspection_status ==  "Carry Forward" ||
            item.inspection_status == "Pending" ||
            item.inspection_status == "Scheduled" ||
            item.inspection_status == "Cancel"
          ) {
            this.checked_values.push(item.inspection_id);
          }
          // this.inspection_checked.push(this.inspection_checkedList[key]);
        }

        console.log("this.inspection_checked ", this.checked_values);
      } else {
        this.checked_values = [];
        console.log("unchecked-------------------> ", this.checked_values);
      }
    },

    verifyChecked: function(id) {
      this.checked_values.map((inspection_id) => {
        if (inspection_id == id) return true;
      });
      return false;
    },

    handleCheck: function(id, action) {
      // console.log(id)
      // if (action === true) {
      //   this.checked_values.push(id)
      // }
      // else {
      //   this.checked_values = this.checked_values.filter((inspectionId) => inspectionId!==id)
      // }
      console.log(this.checked_values);
      console.log(this.approvedcount, "approvedcount");
      if (this.checked_values.length != this.approvedcount) {
        this.isCheckAll = false;
      }
      if (this.checked_values.length == this.approvedcount) {
        this.isCheckAll = true;
      }
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    clearformdata: function() {
      (this.inspectionzone = ""); 
      (this.inspectionStyleType ="");
      (this.location = "");
      this.seachdata = [];
      (this.inspectionStatus = "");
       (this.uploaded_inspection_type = "");
      this.inspection_date = "";
      this.inspection_to_date = "";
      this.inspection_qcname = [];
      this.buyer_search_name = [];
      this.vendor_search_name = [];
      this.getinspectionlisting(1);
    },

    closeInspectionInvalidRecords() {
      this.showInspectionInvalidRecords = false;
    },

    downloadInvalidrecordsData(){
      document.getElementById("overlay").style.display = "block";
      console.log(this.invalidIdOfRecords)
      const Obj = {
        user_type: this.user_type,
        invalid_inspectionId: this.invalidIdOfRecords
      };
      axios
        .post(`${CONSTANTS.API_URL}/donwloadInvalidInspectionWithError`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          if(response.data.returnmsg === 'Unsuccessful'){
            this.$fire({
              text: "Something went wrong",
              type: "error",
              timer: 30000,
            });

          }
          else {
            this.downloadHelper(response.data);
            this.showInspectionInvalidRecords = false;

          }
        })
    },

    getallSubcategoryData(){
      axios
        .post(`${CONSTANTS.API_URL}/downloadSubcatDetatilsForInspection`, {})
        .then((response) => {
          // console.log(response);
          this.downloadHelper(response.data);
        }).catch((error)=>{
          console.error("error while downloading subcategory file",error);
        });
    }


  },
};
</script>
<style>
.loct {
    white-space: pre-line;
}

.img-magnifier-container {
  position: relative;
}

.img-magnifier-glass {
  position: absolute;
  border: 3px solid #000;
  border-radius: 50%;
  cursor: none;
  /*Set the size of the magnifier glass:*/
  width: 200px;
  height: 200px;
}

.account-settings__content > * {
  flex-grow: 1;
}

.profile-settings {
  flex-grow: 1;
  padding: 20px 24px;
}

.profile-settings > h1 {
  font-weight: 600;
  padding: 0;
  margin: 0;
}
.profile-settings .content {
  display: flex;
}
.profile-settings .content .profile-fields-container {
  max-width: 356px;
  margin-right: 56px;
}
.profile-settings .tabular-fields {
  font-size: 14px;
  line-height: 20px;
  flex-direction: column;
}
.profile-settings .tabular-fields .field-row {
  margin-top: 20px;
  min-height: 44px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.profile-settings .tabular-fields .field-row > .field-label {
  color: var(--fill-grey-medium);
  min-width: 100px;
  margin: 12px 0;
}
.profile-settings .tabular-fields .field-row > .field-value {
  margin-left: 32px;
  flex-grow: 1;
}

.design-container-details__main {
  background-color: white;
  border-left: 1px solid #d4d4d4;
}

.profile-settings .content .img.img-invalid {
  background-color: #6f4ce6;
}
.profile-settings .content .img {
  max-width: 100%;
  position: relative;
  height: 175px;
  width: 175px;
  border-radius: 4px;
  overflow: hidden;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  border: 1px solid var(--fill-grey-light2);
  padding: 5px;
}

/*****CSS For Zoom Image*****/
*body {
  margin: 0;
}
#btn_navbar {
  overflow: hidden;
  text-align: center;
  /*position: fixed;*/
  top: 0;
  width: 100%;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 20px;
}
#btn_navbar a {
  float: left;
  display: block;
  color: #666;
  text-align: center;
  padding-right: 20px;
  text-decoration: none;
  font-size: 17px;
}
#btn_navbar a:hover {
  background-color: #ddd;
  color: black;
}
#btn_navbar a.active {
  background-color: #4caf50;
  color: white;
}
.main1 {
  padding: 16px;
  margin-top: 30px;
}
.main1 img {
  max-width: 100%;
  height: auto;
}
.button {
  width: 300px;
  height: 60px;
}

.detailimgborder {
  width: 300px;
  float: left;
  border: 1px solid lightgray;
}
.detailsmodalimg {
  height: 150px;
  width: 250px;
  padding: 5px;
}
.summaryzoombtn {
  padding: 5px;
  margin-left: 30%;
  margin-bottom: 10px;
}
@media screen and (max-width: 1040px) {
  .summarytableset {
    display: none;
  }
}
@media screen and (min-width: 1040px) {
  .tablemd {
    display: none;
  }
}
@media screen and (max-width: 530px) {
  #tablesm {
    display: none;
  }
}
@media screen and (max-width: 1040px) and (min-width: 992px) {
  .summarymodel {
    flex: 0 0 50%;
    max-width: 47%;
  }
}
@media screen and (max-width: 990px) {
  .summarymodel {
    flex: 0 0 50%;
    max-width: 47%;
  }
  .designsummaryipad {
    flex: 0 0 90%;
    max-width: 100%;
  }
  .detailsmodalimg {
    height: 150px;
    width: 250px;
    padding: 5px;
  }
  .detailimgborder {
    width: 205px;
    float: left;
    border: 1px solid lightgray;
  }
  .designsummary {
    margin-top: 10px;
  }
}
@media screen and (max-width: 766px) and (min-width: 480px) {
  /*.summarymodel{
    flex: 0 0 50%;
    max-width: 47%;
}
.designsummaryipad{
   flex: 0 0 90%;
    max-width: 100%;
}*/
  .detailsmodalimg {
    height: 150px;
    width: 250px;
    padding: 5px;
  }
  .detailimgborder {
    width: 255px;
    float: left;
    border: 1px solid lightgray;
  }
  .designsummary {
    margin-top: 10px;
  }
  .designsummarycol5 {
    width: 120px;
  }
  .designsummarycol1 {
    width: 10px;
  }
}
@media screen and (max-width: 479px) and (min-width: 350px) {
  .summarymodel {
    flex: 0 0 50%;
    max-width: 20%;
  }
  .detailsmodalimg {
    height: 150px;
    width: 250px;
    padding: 5px;
  }
  .detailimgborder {
    width: 200px;
    float: left;
    border: 1px solid lightgray;
  }
  .designsummary {
    margin-top: 10px;
    padding-left: 0px;
  }
  .designsummaryipad {
    font-size: 12px;
  }
  .designsummarycol1 {
    width: 10px;
  }
  .designsummarycol5 {
    width: 115px;
  }
}
@media screen and (max-width: 349px) {
  .summarymodel {
    flex: 0 0 50%;
    max-width: 15%;
  }
  .detailsmodalimg {
    height: 150px;
    width: 250px;
    padding: 5px;
  }
  .detailimgborder {
    width: 150px;
    float: left;
    border: 1px solid lightgray;
  }
  .designsummary {
    margin-top: 10px;
    padding-left: 0px;
  }
  .designsummaryipad {
    font-size: 11px;
  }
  .summaryzoombtn {
    padding: 5px;
    margin-left: 25%;
    margin-bottom: 10px;
    font-size: 10px;
  }
  .designsummarycol1 {
    width: 10px;
  }
  .designsummarycol5 {
    width: 80px;
  }
}
@media (max-width: 450px) {
  .sumtdhset {
    font-size: 10px;
  }
  .sumtdhunit {
    font-size: 10px;
  }
  .sumtdhagefrom {
    font-size: 10px;
  }
  .sumtdhageto {
    font-size: 10px;
  }
  .sumtdhsize {
    font-size: 10px;
  }
  .sumtdhquantity {
    font-size: 10px;
  }
  .sumtdbquantity {
    width: 60px;
  }
  .sumtdbsize {
    width: 60px;
  }
  .sumtdbunit {
    padding: 0px;
    height: 33px !important;
    width: 50px;
  }
  .sumtdbfage {
    padding: 0px;
    height: 33px !important;
    width: 50px;
  }
  .sumtdbtage {
    padding: 0px;
    height: 33px !important;
    width: 50px;
  }
  .detailimgborder {
    margin-top: -26px;
  }
}
</style>
